import styled from 'styled-components';

export const MainContainer = styled.div`
  width: 100%;
  text-align: center;
  
  & .phone-icon {
    margin-top: 184px;
    margin-bottom: 40px;
    width: 98px;
    height: 120px;
  }
  
  & .button-back {
    margin-top: 48px;
    font-weight: 600;
  }

  & .button-exit {
    background-color: #fff;
    color: #7B00B2;
    font-family: Rubik;
    letter-spacing: 0.15px;
    line-height: 24px;
    font-weight: 600;
  }
`;

export const Title = styled.div`
  color: #333333;
  font-size: 24px;
  font-weight: 600;
  letter-spacing: 0.18px;
  line-height: 32px;
`;

export const Description = styled.div`
  color: #666666;
  font-size: 16px;
  letter-spacing: 0.15px;
  line-height: 26px;
  text-align: center;
  margin-top: 32px;

`;